import { render, staticRenderFns } from "./roster-table-pullup.vue?vue&type=template&id=90d9de0c&scoped=true&"
import script from "./roster-table-pullup.ts?vue&type=script&lang=ts&"
export * from "./roster-table-pullup.ts?vue&type=script&lang=ts&"
import style0 from "./roster-table-pullup.scss?vue&type=style&index=0&id=90d9de0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d9de0c",
  null
  
)

export default component.exports